import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css"; // Importar estilos de AOS
import AboutCard from "../../components/about/card_about";
import ValueCard from "../../components/about/card_value";
import { FaHands, FaRegEye } from "react-icons/fa";
import Breadcum from "../../components/breadcum";
import ValuesCarrousel from "../../components/about/carrousel_values";

const Filosofia = () => (
  <p className="text-gray-700 text-xl leading-relaxed">
    En <strong>Border Protect Seguridad Privada</strong>, nos regimos por
    principios sólidos que garantizan la excelencia en cada uno de nuestros
    servicios. Creemos que la seguridad no es solo una necesidad, sino un
    derecho fundamental. Nuestra filosofía se basa en la mejora continua, la
    profesionalización del personal y el cumplimiento riguroso de todas las
    normativas legales vigentes.
  </p>
);

export default function About() {
  useEffect(() => {
    AOS.init({ duration: 800, easing: "ease-in-out", once: true });
  }, []);

  return (
    <div className="bg-neutral-100">
      <section className="mx-auto max-w-screen-2xl px-6 lg:px-8 py-36" id="nosotros">
        <div className="text-left mb-16">
          <div data-aos="fade-up">
            <Breadcum text="Nuestros Valores" />
            <h1 className="text-4xl md:text-5xl font-bold text-gray-800 leading-tight mb-5">
              Nuestra Filosofía
            </h1>
            <Filosofia />
          </div>
          <div className="grid grid-cols-12 gap-8 mb-16 mt-5">
            <div className="md:col-span-6 col-span-12" data-aos="fade-right">
              <AboutCard
                title="Misión"
                text={
                  <p>
                    Brindar tranquilidad y protección integral a nuestros
                    clientes mediante soluciones de seguridad confiables,
                    eficientes y personalizadas.
                    <p className="mt-3">
                      Nos enfocamos en garantizar la integridad de bienes y
                      personas con tecnología de vanguardia, talento humano
                      capacitado y estrategias innovadoras.
                    </p>
                  </p>
                }
                icon={<FaHands />}
              />
            </div>
            <div className="md:col-span-6 col-span-12" data-aos="fade-left">
              <AboutCard
                title="Visión"
                text={`Convertirnos en la empresa líder en seguridad privada a nivel
                nacional, reconocida por nuestro profesionalismo, innovación y
                alto nivel de satisfacción de nuestros clientes.`}
                icon={<FaRegEye />}
              />
            </div>
          </div>
          <div data-aos="fade-up">
            <ValuesCarrousel />
          </div>
        </div>
      </section>
    </div>
  );
}
